export default "__VITE_PUBLIC_ASSET__ba1a223b__"